<template>
  <el-dialog custom-class="pc-dialog pc-dialog__insert-image"
    :title="title"
    :visible.sync="visible"
    width="90rem"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closeHandler"
    @open="openHandler"
    >
    <div class="pc-dialog__insert-image-input">
      <el-input v-model="text" size="small" placeholder="输入图片名称检索" clearable
        @keyup.native.enter="searchHandler"></el-input>
    </div>
    <div class="pc-dialog__insert-image-loading" v-if="loading">
      <i class="el-icon-loading"></i>
    </div>
    <div class="pc-dialog__insert-image-list" v-if="!loading">
      <insert-image-item v-for="item in images" :key="item.md5" :data="item"
        :selected="isSelected(item.md5)"
        @select="selectImageHandler"></insert-image-item>
    </div>
    <div slot="footer" class="pc-dialog__insert-image-footer">
      <div class="middle">
        <el-pagination
          background
          :current-page="page"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="totalCount"
          @current-change="pageChangeHandler"
        ></el-pagination>
      </div>
      <el-button type="primary" size="small" @click="insertHandler" :disabled="selected.length === 0">插入选中图片 ({{selected.length}})</el-button>
      <el-button size="small" @click="showUploadImageDialogHandler">上传图片</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import InsertImageItem from '@/components/image/InsertImageItem.vue'
import _ from 'lodash'
import eventBus from '@/eventbus'
import { operateError } from '@/common/errors'

export default {
  components: {
    InsertImageItem
  },
  name: 'InsertImageDialog',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('dialog', {
      insertImage: 'insertImage'
    }),
    ...mapGetters('image', {
      searchState: 'search'
    }),
    visible: {
      get () {
        return this.insertImage.visible
      },
      set (value) {
        this.setInsertImage({ visible: value })
      }
    },
    title () {
      return `插入图片 (${this.totalCount} 张)`
    },
    text: {
      get () {
        return this.searchState.text
      },
      set (value) {
        this.setSearchText(value)
      }
    },
    page () {
      return this.searchState.result.page
    },
    pageSize () {
      return this.searchState.pageSize
    },
    images () {
      return this.searchState.result.list
    },
    totalCount () {
      return this.searchState.result.totalCount
    },
    loading () {
      return this.searchState.loading
    },
    isSelected () {
      return (md5) => {
        return this.selected.indexOf(md5) > -1
      }
    },
    selected: {
      get () {
        return this.searchState.selected
      },
      set (value) {
        this.setSearchSelected(value)
      }
    }
  },
  methods: {
    ...mapMutations('dialog', {
      setInsertImage: 'SET_INSERT_IMAGE',
      setUploadImage: 'SET_UPLOAD_IMAGE'
    }),
    ...mapMutations('image', {
      setSearchText: 'SET_SEARCH_TEXT',
      setSearchSelected: 'SET_SEARCH_SELECTED'
    }),
    ...mapActions('image', {
      searchImages: 'searchImages'
    }),
    closeHandler () {
    },
    async openHandler () {
      this.setSearchText('')
      await this.search(1)
    },
    showUploadImageDialogHandler () {
      this.setUploadImage({
        visible: true
      })
    },
    async searchHandler () {
      await this.search(1)
    },
    async pageChangeHandler (current) {
      await this.search(current)
    },
    async search (page) {
      try {
        await this.searchImages({ page: page || 1 })
      } catch (e) {
        console.dir(e)
        operateError(e, '加载图片')
      }
    },
    insertHandler () {
      const files = _.filter(this.images, (n) => _.indexOf(this.selected, n.md5) > -1)
      const images = _.map(files, (n) => {
        return `\r\n![${n.name}](${n.src})`
      })
      eventBus.$emit('WORKBENCH_CODEMIRROR_EDITOR_INSERT_TEXT', images.join(''))
      this.setInsertImage({
        visible: false
      })
    },
    selectImageHandler (md5) {
      if (this.selected.indexOf(md5) > -1) {
        _.remove(this.selected, n => n === md5)
        this.selected = [...this.selected]
      } else {
        this.selected.push(md5)
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-dialog__insert-image {
  width: 90rem;
  max-width: 90vw;
  margin: 10vh auto !important;
  height: 80vh;
  display: flex;
  flex-direction: column;
  .el-dialog__body {
    height: 0;
    flex: 1;
    overflow: auto;
    padding: 0 2rem 1rem 2rem;
  }
}

.pc-dialog__insert-image-footer {
  display: flex;
  flex-direction: row;

  .middle {
    flex-grow: 1;
    justify-content: left;
    align-items: center;
    display: flex;
  }

  .el-pagination {
    padding-left: 0;
  }

  .btn-prev {
    margin-left: 0 !important;
  }
}

.pc-dialog__insert-image-input {
  position: sticky;
  top: 0;
  background: white;
  padding: 1rem 0;
  z-index: 2;
}

.pc-dialog__insert-image-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
}

.pc-dialog__insert-image-loading {
  text-align: center;
  margin-top: 2rem;
  .el-icon-loading {
    font-size: 2rem;
    color: $color-b3;
  }
}
</style>
